import { put } from 'redux-saga/effects';
import {
  getAllQuestionsFailed,
  getAllQuestionsSuccess,
} from '../../actions/questions';
import { GET_ALL_QUESTIONS } from '../../constants/urls';
import { openErrorToast } from '../../reducers/uiLogic';
import zfetch, { METHOD_GET } from '../../pages/common/utils/zfetch';

const getAllQustions = () => {
  const options = {
    method: METHOD_GET,
  };
  return zfetch(GET_ALL_QUESTIONS, options);
};

export function* getAllQustionsSaga(action) {
  let questionsData = {};

  try {
    const response = yield getAllQustions(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    questionsData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getAllQuestionsFailed(err));
    yield put(openErrorToast('Failed to get questions!'));
    return;
  }

  yield put(getAllQuestionsSuccess(questionsData));
}
